import React from 'react';
import useCarousel from './hooks/useCarousel';
import HeroSlide from './HeroSlide';
import HeroNavigation from './HeroNavigation';
import HeroIndicators from './HeroIndicators';
import styles from './styles/HomeHero.module.css';

/**
 * Componente principal del Hero de la Home
 * @param {Array} banners - Array de configuración de banners
 * @param {Object} options - Opciones del carrusel
 */
const HomeHero = ({ banners = [], options = {} }) => {
  const {
    autoplay = true,
    interval = 8000,
    pauseOnHover = true,
    loop = true
  } = options;

  // Filtrar solo banners activos
  const activeBanners = banners.filter(banner => banner.active !== false);

  const {
    currentIndex,
    currentItem,
    next,
    prev,
    goTo,
    touchHandlers,
    hoverHandlers
  } = useCarousel(activeBanners, {
    autoplay,
    interval,
    pauseOnHover,
    loop
  });

  if (!activeBanners.length) {
    return (
      <div className={styles.emptyHero}>
        <p>No hay banners disponibles en este momento</p>
      </div>
    );
  }

  const showNavigation = activeBanners.length > 1;

  return (
    <div 
      className={styles.homeHero}
      {...touchHandlers}
      {...hoverHandlers}
    >
      <div className={styles.heroContainer}>
        {/* Navegación */}
        {showNavigation && (
          <HeroNavigation 
            onPrev={prev} 
            onNext={next}
            showPrev={loop || currentIndex > 0}
            showNext={loop || currentIndex < activeBanners.length - 1}
          />
        )}

        {/* Slide actual */}
        <HeroSlide banner={currentItem} />

        {/* Indicadores */}
        {showNavigation && (
          <HeroIndicators 
            total={activeBanners.length}
            current={currentIndex}
            onSelect={goTo}
          />
        )}
      </div>
    </div>
  );
};

export default HomeHero;
